// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1586": "7a7fc588c804","3922": "57d5af9355c6","761": "2852deec03a3",}[chunkId] + ".css"
}